import axios from "axios";
import {HTTP_RESPONSE} from "../../Utility/Helpers/constants";
import UserProvier from "../../../security/UserProvier";
import AuthorizationChecker from "../../../security/AuthorizationChecker";

UserProvier.setToken();

export const DATA_API_URL_VENDOR = process.env.REACT_APP_API_BASE_URL + 'products-vendor';
export const DATA_API_URL_MONDOU = process.env.REACT_APP_API_BASE_URL + 'products-mondou';

export const DATA_API_FIELDS_URL_VENDOR = process.env.REACT_APP_API_BASE_URL + 'product-columns-vendor';
export const DATA_API_FIELDS_URL_MONDOU = process.env.REACT_APP_API_BASE_URL + 'product-columns-mondou';

export const DATA_API_URL_PROJECT_REFERENCES = process.env.REACT_APP_API_BASE_URL + 'product-references/';

export const PRODUCT_PICS_API_URL = process.env.REACT_APP_API_BASE_URL + 'product-photos/';
export const IMPORT_PRODUCTS_API_URL = DATA_API_URL_VENDOR + "/import/p="

const queries = (itemPerPage = 15, page = 1, search = '',projectId) => {
    return getApiUrl() + '?filter[where][and][1][projectId]='+projectId+
        '&filter[order]=id DESC'+
        (UserProvier.get().companyId==1 ? includeFilter : includeFilterRen) +
        '&filter[limit]=' + itemPerPage + '&filter[skip]=' + (((page - 1) * itemPerPage) > 0 ? ((page - 1) * itemPerPage) : 0);
}


const queriesReferences = (itemPerPage = 15, page = 1, search = '',field) => {
    return DATA_API_URL_PROJECT_REFERENCES + field +'?s='+search+'&filter[limit]=' + itemPerPage +
        '&filter[skip]=' + ((page - 1) * itemPerPage > 0 ? (page - 1) * itemPerPage : 0)
}


const getFindIncludeAllApiUrl = (id, projectId) =>{
    return getApiUrl() + '?filter[where][id]='+id +
        '&filter[where][and][1][projectId]='+projectId+
        (UserProvier.get().companyId==1 ? includeFilter : includeFilterRen)
}

const getApiUrl = ()=>{
    return  AuthorizationChecker.isGranted(["VENDOR_READ_PROJECT"]) ? DATA_API_URL_VENDOR :
            AuthorizationChecker.isGranted(["BUYER_READ_PROJECT"]) ? DATA_API_URL_MONDOU :
            AuthorizationChecker.isGranted(["MD_READ_PROJECT"]) ? DATA_API_URL_MONDOU :
            AuthorizationChecker.isGranted(["ECOM_READ_PROJECT"]) ? DATA_API_URL_MONDOU :
            AuthorizationChecker.isGranted(["ADMIN_READ_PROJECT"]) ? DATA_API_URL_MONDOU :
            ""
}

const getFieldsApiUrl = ()=>{
    return  AuthorizationChecker.isGranted(["VENDOR_READ_PROJECT"]) ? DATA_API_FIELDS_URL_VENDOR :
            AuthorizationChecker.isGranted(["BUYER_READ_PROJECT"]) ? DATA_API_FIELDS_URL_MONDOU :
            AuthorizationChecker.isGranted(["MD_READ_PROJECT"]) ? DATA_API_FIELDS_URL_MONDOU :
            AuthorizationChecker.isGranted(["ECOM_READ_PROJECT"]) ? DATA_API_FIELDS_URL_MONDOU :
            AuthorizationChecker.isGranted(["ADMIN_READ_PROJECT"]) ? DATA_API_FIELDS_URL_MONDOU :
            ""
}

// TODO : Find Include All

const ProductsRepository = {
    
    findNiveauN: (n, parentId=0, search="")=>{
        return axios
          .get(DATA_API_URL_PROJECT_REFERENCES+"niveau/"+n+"/"+parentId+"?s="+search)
          .then((response) => {
            return response.data.items
          })
          .catch((e) => {
            if (e.response) {
              throw e.response
            } else {
              throw { ...e, status: HTTP_RESPONSE.HTTP_NOT_FOUND }
            }
          })
    },
    findReferences : (page = 1, itemPerpage = 10, search = '', field) => {
        return axios
            .get(queriesReferences(itemPerpage, page, search,field))
            .then(response => {
                return response.data;
            }).catch((e) => {
                if (e.response) {
                    throw e.response;
                } else {
                    throw {...e, status: HTTP_RESPONSE.HTTP_NOT_FOUND};
                }
            });
    },
    findReferencesWithHierachie :(field, parentId=0, search="")=>{
        return axios
          .get(DATA_API_URL_PROJECT_REFERENCES+field+"/"+parentId+"?s="+search)
          .then((response) => {
            return response.data.items
          })
          .catch((e) => {
            if (e.response) {
              throw e.response
            } else {
              throw { ...e, status: HTTP_RESPONSE.HTTP_NOT_FOUND }
            }
          })
    },
    add : (item) => {
        return axios
            .post(getApiUrl(), item).then(response => {
                return response.data;
            }).catch((e) => {
                if (e.response) {
                    throw e.response;
                } else {
                    throw {...e, status: HTTP_RESPONSE.HTTP_NOT_FOUND};
                }
            });
    },
    edit: (item) => {
        return axios
            .put(getApiUrl() + '/' + item.id, item).then(response => {
                return response.data;
            }).catch((e) => {
                if (e.response) {
                    throw e.response;
                } else {
                    throw {...e, status: HTTP_RESPONSE.HTTP_NOT_FOUND};
                }
            });
    },
    editWithoutValidation: (item) => {
        return axios
            .put(getApiUrl() + '/' + item.id + '/no-valid', item).then(response => {
                return response.data;
            }).catch((e) => {
                if (e.response) {
                    throw e.response;
                } else {
                    throw {...e, status: HTTP_RESPONSE.HTTP_NOT_FOUND};
                }
            });
    },
    editAll : (items)=>{
        //loop trought items and modify dateLivraisonPossible and availableToShipToRen to remove time part if exist and set
        for (let i = 0; i < items.length; i++) {
            if(items[i].dateLivraisonPossible && items[i].dateLivraisonPossible.includes("T")){
                items[i].dateLivraisonPossible = items[i].dateLivraisonPossible.split("T")[0]
            }
            if(items[i].availableToShipToRen && items[i].availableToShipToRen.includes("T")){
                items[i].availableToShipToRen = items[i].availableToShipToRen.split("T")[0]
            }
        }
        return axios
            .put(getApiUrl() + '/no-valid', items).then(response=>{
                return response.data;
            }).catch((e) => {
                if (e.response) {
                    throw e.response;
                } else {
                    throw {...e, status: HTTP_RESPONSE.HTTP_NOT_FOUND};
                }
            });
    },
    validateProducts : (items) =>{
        return axios
        .post(getApiUrl()+"/validate", items).then(response=>{
            return response.data;
        }).catch((e) => {
            if (e.response) {
                throw e.response;
            } else {
                throw {...e, status: HTTP_RESPONSE.HTTP_NOT_FOUND};
            }
        });
    },
    savePics : (item, productId) => {
        const config = {
            headers: {
                'content-type': 'multipart/form-data'
            }
        }
        return axios
            .post(PRODUCT_PICS_API_URL+productId, item,config).then(response => {
                return response.data;
            }).catch((e) => {
                if (e.response) {
                    throw e.response;
                } else {
                    throw {...e, status: HTTP_RESPONSE.HTTP_NOT_FOUND};
                }
            });
    },
    getPics : (productId) => {
        return axios
            .get(PRODUCT_PICS_API_URL+productId).then(response => {
                return response.data;
            }).catch((e) => {
                if (e.response) {
                    throw e.response;
                } else {
                    throw {...e, status: HTTP_RESPONSE.HTTP_NOT_FOUND};
                }
            });
    },
    delPic : (productId, name) => {
        return axios
            .delete(PRODUCT_PICS_API_URL+productId+"/f="+name).then(response => {
                return response.data;
            }).catch((e) => {
                if (e.response) {
                    throw e.response;
                } else {
                    throw {...e, status: HTTP_RESPONSE.HTTP_NOT_FOUND};
                }
            });
    },
    importProducts : (item, associatedProjectId) => {
        const config = {
            headers: {
                'content-type': 'multipart/form-data'
            }
        }
        return axios
            .post(IMPORT_PRODUCTS_API_URL+associatedProjectId, item,config).then(response => {
                return response.data;
            }).catch((e) => {
                if (e.response) {
                    throw e.response;
                } else {
                    throw {...e, status: HTTP_RESPONSE.HTTP_NOT_FOUND};
                }
            });
    },
    findAll : (page = 1, itemPerpage = 10, search = '', projectId) => {
        return axios
            .get(queries(itemPerpage, page, search,projectId))
            .then(response => {
                return response.data;
            }).catch((e) => {
                if (e.response) {
                    throw e.response;
                } else {
                    throw {...e, status: HTTP_RESPONSE.HTTP_NOT_FOUND};
                }
            });
    },
    findIncludeAll: (id,projectId) => {
      return axios
            .get(getFindIncludeAllApiUrl(id,projectId))
            .then(response => {
                return response.data;
            }).catch((e) => {
                if (e.response) {
                    throw e.response;
                } else {
                    throw {...e, status: HTTP_RESPONSE.HTTP_NOT_FOUND};
                }
            });
    },
    flush: (item) => {
        if (item.id) {
            return ProductsRepository.edit(item)
        } else {
            return ProductsRepository.add(item);
        }
    },
    find : (id) => {
        return axios
            .get(getApiUrl() + '/' + id)
            .then(response => {
                return response.data;
            }).catch((e) => {
                if (e.response) {
                    throw e.response;
                } else {
                    throw {...e, status: HTTP_RESPONSE.HTTP_NOT_FOUND};
                }
            });
    },
    remove : (id) => {
        return axios.delete(getApiUrl() + '/' + id).then((response) => {
            return id
        }).catch((e) => {
            if (e.response) {
                throw e.response;
            } else {
                throw {...e, status: HTTP_RESPONSE.HTTP_NOT_FOUND};
            }
        });
    },
    findFields : () => {
        return axios
            .get(getFieldsApiUrl())
            .then(response => {
                return response.data;
            }).catch((e) => {
                if (e.response) {
                    throw e.response;
                } else {
                    throw {...e, status: HTTP_RESPONSE.HTTP_NOT_FOUND};
                }
            });
    },

}
export default ProductsRepository;

const includeFilter = "&filter[include][]=brand&filter[include][]=niveau1&filter[include][]=niveau2&filter[include][]=niveau3&filter[include][]=niveau4&filter[include][]=niveau5&filter[include][]=niveau6&filter[include][]=marque&filter[include][]=taille&filter[include][]=formatAccessoire&filter[include][]=formatSac&filter[include][]=couleur&filter[include][]=saveur1&filter[include][]=saveur2&filter[include][]=saveur3&filter[include][]=costPer&filter[include][]=devise&filter[include][]=paysOrigin&filter[include][]=groupeAutorisation&filter[include][]=codeABC&filter[include][]=planoDesignation&filter[include][]=prodWeb&filter[include][]=saison&filter[include][]=acheteuse&filter[include][]=approvisionneuse&filter[include][]=cadence&filter[include][]=rythme&filter[include][]=regleAppro&filter[include][]=uniteAchat&filter[include][]=uniteSortie&filter[include][]=benefice1&filter[include][]=benefice2&filter[include][]=benefice3&filter[include][]=benefice4&filter[include][]=categoriePrimaire1&filter[include][]=categoriePrimaire2&filter[include][]=categoriePrimaire3&filter[include][]=categoriePrimaire4&filter[include][]=categoriePrimaire5&filter[include][]=categorieSecondaire1&filter[include][]=categorieSecondaire2&filter[include][]=categorieSecondaire3&filter[include][]=categorieSecondaire4&filter[include][]=categorieSecondaire5&filter[include][]=faitEn1&filter[include][]=faitEn2&filter[include][]=faitEn3&filter[include][]=faitEn4&filter[include][]=soinSpecifique1&filter[include][]=soinSpecifique2&filter[include][]=soinSpecifique3&filter[include][]=soinSpecifique4&filter[include][]=besoinSpecifique1&filter[include][]=besoinSpecifique2&filter[include][]=besoinSpecifique3&filter[include][]=besoinSpecifique4&filter[include][]=stadeVie&filter[include][]=tailleRace&filter[include][]=typeNourriture&filter[include][]=gamme&filter[include][]=typeLitiere&filter[include][]=litiereParfumee&filter[include][]=certification1&filter[include][]=certification2&filter[include][]=certification3&filter[include][]=texture&filter[include][]=qualite&filter[include][]=perissable&filter[include][]=origineMarque&filter[include][]=tracabiliteIngredients&filter[include][]=exclusifMondou&filter[include][]=vrac&filter[include][]=codeTVA&filter[include][]=recurrence"
const includeFilterRen ="&filter[include][]=divisionCode&filter[include][]=itemCategoryCode&filter[include][]=productGroupCode&filter[include][]=petFilter&filter[include][]=lifeStageFilter&filter[include][]=breedSizeFilter&filter[include][]=specialtyDietFilter&filter[include][]=healthNutritionFilter&filter[include][]=seasonCode&filter[include][]=vendorCurrency&filter[include][]=msrpCurrency&filter[include][]=vendorUOM"